import { render } from "./Cascades.vue?vue&type=template&id=8c82daf6&ts=true"
import script from "./Cascades.vue?vue&type=script&lang=ts"
export * from "./Cascades.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__